import { useFormContext } from 'react-hook-form';

import { FieldArrayWithId } from 'react-hook-form/dist/types/fieldArray';

import { Grid } from '@mui/material';

import { useFieldArrayContext } from 'components/shared/CRUD/components/InnerPage/hooks/useFieldArrayContext';
import useFindIndexFromFieldsArray from 'components/shared/CRUD/hooks/useFindIndexFromFieldsArray';

import {
  DistanceRangeFromField,
  DistanceRangeToField,
  ExpensesMaxField,
  ExpensesNominalField,
  ExpensesPerDistanceField,
  ValidFromField,
  ValidToField
} from './components/TravelLineFields';

const getLastAddedFieldId = (fields: FieldArrayWithId[]) =>
  fields.slice(-1)[0]?.id;

const EditTravelLine = ({ rowId }) => {
  const { control } = useFormContext();
  const { fields } = useFieldArrayContext();
  const fieldIndex = useFindIndexFromFieldsArray(
    rowId ?? getLastAddedFieldId(fields),
    fields
  );

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <DistanceRangeFromField
            name={`travelSetLines[${fieldIndex}].distanceRangeFrom`}
          />
        </Grid>
        <Grid item xs={6}>
          <DistanceRangeToField
            name={`travelSetLines[${fieldIndex}].distanceRangeTo`}
          />
        </Grid>
        <Grid item xs={4}>
          <ExpensesPerDistanceField
            name={`travelSetLines[${fieldIndex}].expensesPerDistance`}
          />
        </Grid>
        <Grid item xs={4}>
          <ExpensesNominalField
            name={`travelSetLines[${fieldIndex}].expensesNominal`}
          />
        </Grid>
        <Grid item xs={4}>
          <ExpensesMaxField
            name={`travelSetLines[${fieldIndex}].expensesMax`}
          />
        </Grid>
        <Grid item xs={6}>
          <ValidFromField
            name={`travelSetLines[${fieldIndex}].valid.from`}
            control={control}
          />
        </Grid>
        <Grid item xs={6}>
          <ValidToField
            name={`travelSetLines[${fieldIndex}].valid.to`}
            control={control}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default EditTravelLine;
